import SidesheetHeader from "components/Dashboard/DoctorDashboard/views/one-one-sessions/components/layout/components/calendar-sidebar/components/sidesheet-header/SidesheetHeader";
import { useDispatch } from "react-redux";
import { closeSidesheet } from "store/calendarSidebarSlice";
import { PRO_CALENDAR_ANALYTICS_PAGE_NAME, track } from "utils/amplitude";
import getClasses from "utils/getClasses";
import AddOrEditBlockInterval from "../../../add-to-calendar/components/add-or-edit-block-interval/AddOrEditBlockInterval";
import styles from "../../BlockedIntervalSidesheet.module.scss";

const AMPLITUDE_COMPONENT_NAME = "blocked-interval-sidesheet";

const EditBlockedInterval: React.FC<{
  blockedInterval: CalendarBlockedInterval;
}> = ({ blockedInterval }) => {
  const dispatch = useDispatch();

  return (
    <>
      <SidesheetHeader
        title="Edit Block"
        onClose={() => {
          track(
            PRO_CALENDAR_ANALYTICS_PAGE_NAME,
            [AMPLITUDE_COMPONENT_NAME, "close-button"],
            "click",
          );
          dispatch(closeSidesheet());
        }}
        className={getClasses(styles["title"], styles["title--edit"])}
      />

      <AddOrEditBlockInterval
        currentBlockedInterval={blockedInterval}
        setIsDirty={() => {}}
      />
    </>
  );
};

export default EditBlockedInterval;
